import AddressModalEdit from "../modal/AddressModalEdit";
import React, {useState} from "react";
import Button from '@mui/material/Button';
import Loader from "../loader/Loader";
import { DeleteForever } from "@mui/icons-material";
import { apiBaseUrl } from "../../config";


function SingleAddressCard({item, selected, openEditModal, setCurrentAddress, setRefreshAddresses}) {
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);

    const deleteAddress = async (item)=>{

        const apiUrl = `${apiBaseUrl}customer/delete-address/${item?._id}`;
        console.log(item);
        // alert('delete');

        try {
            const response = await fetch(apiUrl, {
               method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "token": token
                }
            });

            const result = await response.json();

            if (response.ok) {
                setLoading(false)
                setRefreshAddresses(prev => !prev);
                window.location.reload(); // Auto reload after successful delete
            } else {
                setLoading(false)
                console.error("Error add addressing:", result);
            }
        } catch (error) {
            setLoading(false)
            console.error("Error:", error);
        }
    }
    const setAsDefault = async (item) => {
        setLoading(true);
        const apiUrl = `${process.env.REACT_APP_BACKEND_URL}customer/mark-as-default/${item?._id}`;
        try {
            const response = await fetch(apiUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "token": token
                }
            });

            const result = await response.json();

            if (response.ok) {
                setLoading(false)
                setRefreshAddresses(prev => !prev);
                window.location.reload(); // Auto reload after setting as default
            } else {
                setLoading(false)
                console.error("Error add addressing:", result);
            }
        } catch (error) {
            setLoading(false)
            console.error("Error:", error);
        }
    }
    return (
        <>
            {loading && <Loader/>}
            <div className="address-item">
                <div className="address-icon">
                    <i className="fas fa-home"></i>
                </div>
                <div className="address-details">
                    <div className="addressUpperRow">
                    <input type="radio" name="address" value="online"
                           defaultChecked={selected === item._id}
                           onChange={() => {
                               setCurrentAddress(item)
                               const fulladdress = {
                                   addressLine1: item.addressLine1,
                                   addressLine2: item.addressLine2,
                                   district: item.district,
                                   state: item.state,
                                   zip: item.zip,
                               };
                               localStorage.setItem(
                                   "selected-email",
                                   item.email
                               );
                               localStorage.setItem(
                                   "selected-address",
                                   JSON.stringify(fulladdress)
                               );
                               localStorage.setItem("selected-name", item.name);
                           }}/>
                    {item.defaultAddress && <button className="default_address">
                        Default Address
                    </button>
                    }
                    </div>
                    <div className="address-name">{item.name}</div>
                    <div className="address-text">
                        {item.addressLine1} {item.addressLine2 && `, ${item.addressLine2}`}, {item.district}, {item.state}, {item.country}-{item.zip}
                    </div>
                    <div className="address-text">Mobile: {item.mobile}</div>
                    <div className="address-text">Email: {item.email}</div>
                    <div className="btnRow">
                        <button className="remove-coupon" onClick={() => openEditModal(item)} data-bs-toggle="modal" data-bs-target="#addressModaledit">Edit</button>
                        <button className="remove-coupon" onClick={() => deleteAddress(item)}>Remove</button>
                        {!item.defaultAddress && <button className="set-as-default" onClick={() => setAsDefault(item)}>Set as Default</button>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SingleAddressCard